import { cn } from '@/shared/lib/utils';

/** Shimmering placeholder. Used by every panel's loading state. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn('skeleton-shimmer relative overflow-hidden rounded-md bg-surface-2', className)}
      aria-hidden="true"
    />
  );
}
